import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface LoggedInViewProps {
  userName: string;
  userEmail: string;
  onLogout?: (() => Promise<void>) | undefined;
  onSignOutClick?: (() => void) | undefined;
  onSwitchToLogin: () => void;
}

const LoggedInView: React.FC<LoggedInViewProps> = ({
  userName,
  userEmail,
  onLogout,
  onSignOutClick,
  onSwitchToLogin
}) => {
  const handleUseAnotherUser = async () => {
    if (onLogout) {
      await onLogout();
    } else if (onSignOutClick) {
      onSignOutClick();
    } else {
      onSwitchToLogin();
    }
  };

  return (
    <>
      <div className="mt-2">
        <span className="font-bold text-lg text-gray-800">Olá, {userName}</span>
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-600 mt-1">
        <span>{userEmail}</span>
        <CheckCircle2 className="w-5 h-5 text-green-600" />
      </div>
      <div className="text-sm text-gray-600">
        Identificamos seu login ativo na plataforma. Caso não seja você, altere o e-mail e faça login novamente.
      </div>

      <button
        type="button"
        className="mt-4 w-full btn border border-green-600 text-green-600 hover:bg-green-50"
        tabIndex={0}
        aria-label="Usar outro usuário"
        onClick={handleUseAnotherUser}
      >
        Usar outro usuário
      </button>
    </>
  );
};

export default LoggedInView;
